import { useEffect } from 'react';

import { ProductGateway } from '../types/AvantArteProduct';
import Placeholder from './Admin/Placeholder';
import Credits from './Content/Credits';
import Media from './Content/Media';
import MultiMediaCarousel from './Content/MultiMediaCarousel/MultiMediaCarousel';
import QuoteBlok from './Content/QuoteBlok';
import Subheading from './Content/Subheading';
import { useNavigation } from './Layout/Navigation/NavigationContext';
import Artist from './PageTypes/Artist';
import Artists from './PageTypes/Artists';
import Product from './PageTypes/Product';
import SupportBlock from './Support/SupportBlock';
import SupportContact from './Support/SupportContact';
import SupportGetInTouch from './Support/SupportGetInTouch';
import SupportText from './Support/SupportText';

const Components = {
  artist: Artist,
  artists: Artists,
  credits: Credits,
  supportText: SupportText,
  supportBlock: SupportBlock,
  supportContact: SupportContact,
  supportGetInTouch: SupportGetInTouch,
  product: Product,
  subheading: Subheading,
  quote: QuoteBlok,
  media: Media,
  multiMediaCarousel: MultiMediaCarousel,
};

type Props = {
  analytics?: Analytics;
  blok: any;
  index?: number;
  productsGateway?: ProductGateway;
};

const DynamicComponent = (props: Props) => {
  const { setMobileNavOpen } = useNavigation();

  useEffect(() => {
    setMobileNavOpen(false);
  }, []);

  if (
    typeof Components[props.blok.component as keyof typeof Components] !==
    'undefined'
  ) {
    const Component =
      Components[props.blok.component as keyof typeof Components];

    // @ts-expect-error differnet component props
    return <Component {...props} />;
  }
  return <Placeholder componentName={props.blok.component} />;
};

export default DynamicComponent;
